import { title } from "framer-motion/client";


const projects = [
  {
    title: "Look For It",
    description: "An OSINT tool that is build with python.",
    accent: "34, 211, 238", 
    link: "https://github.com/nacimoualla/look-for-it.git"
  },
  {
    title: "Vora",
    description: "A fullstack E-Commerce app working in progress",
    link: "https://github.com/nacimoualla/Vora.git",
    accent: "168, 85, 247", // Purple
  },
  {
    title: "Codex",
    description: "Competitive coding platform.",
    link: "https://github.com/nacimoualla/codex"
  },
  {
    title: "Mirage",
    description: "Honeypot that is designed to get intruders information",
    link: "https://github.com/nacimoualla/Mirage"
  }
];

export default projects;